module.exports = __webpack_public_path__ + "static/media/r4-1.607eb348.png";